import React from 'react';
import { useAsyncState } from '@/utils/hooks';
import { getOrder } from '@/services/orders';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import OrderDetails from '../OrderDetails/OrderDetails';

interface OrderDetailsPageProps {
    orderId: number;
}

const OrderDetailsPage: React.FC<OrderDetailsPageProps> = ({ orderId }) => {
    const [order, , reloadOrder] = useAsyncState(() => getOrder(orderId), [orderId], null);

    if (!order) {
        return <LoadingIndicator />;
    }

    return (
        <OrderDetails
            onOrderChange={() => {
                reloadOrder();
            }}
            order={order}
        />
    );
};

export default OrderDetailsPage;
